import styled from 'styled-components';
import variables from '@styles/variables';
import { rem } from 'polished';
import Heading from '@atoms/Heading/Heading';
import Button from '@atoms/Button/Button';

export const StyledProductDummy = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${variables.colors.white};
  width: calc(100% - ${rem(1)});
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: ${rem(16)};
`;

export const StyledButton = styled(Button)`
  && {
    margin-left: auto;
    margin-right: auto;
    margin-top: ${rem(20)};
  }
`;
